
import { RemoteResult, IdRequest } from "mangdto"
import MainLogic from "@/logic/main_logic"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import Vue from "vue"
import Component from "vue-class-component"

@Component
export default class DatenschutzFiliale extends Vue {
  logic: DatenschutzFilialeLogic = null

  mounted() {
    this.logic = new DatenschutzFilialeLogic()
    this.logic.init(MainLogic.getInstance().filiale.filialeId)
  }
}

class DatenschutzFilialeLogic {
  datenschutz: string

  init(id: string) {
    var request = new IdRequest()
    request.id = id

    Poster.postMember<RemoteResult<string>>(
      RestPaths.filialeDatenschutz,
      request,
    ).then((response) => {
      if (response.data.success) {
        this.datenschutz = response.data.payload
      }
    })
  }
}
